
import {ACTION} from './constants';


let initialState={};

export default function BookreviewInformationReducer(state = initialState, action) {
    switch (action.type) {
        case ACTION.GET_INFORMATION_DETAIL_CONTENT :
            return {...state, ...action.data};   
        case ACTION.SMILE_FEEDBACK:
            return { ...state, readingroomfeedback: action.data};
        default:
            return state;
    }
}
